exports.version = "2.3.5"


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/apollo-client/version.js
// module id = 306
// module chunks = 0